/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterContentAddPost } from '../fn/content/api-master-content-add-post';
import { ApiMasterContentAddPost$Params } from '../fn/content/api-master-content-add-post';
import { apiMasterContentApproveRejectPost } from '../fn/content/api-master-content-approve-reject-post';
import { ApiMasterContentApproveRejectPost$Params } from '../fn/content/api-master-content-approve-reject-post';
import { apiMasterContentDeleteGet } from '../fn/content/api-master-content-delete-get';
import { ApiMasterContentDeleteGet$Params } from '../fn/content/api-master-content-delete-get';
import { apiMasterContentEditPost } from '../fn/content/api-master-content-edit-post';
import { ApiMasterContentEditPost$Params } from '../fn/content/api-master-content-edit-post';
import { apiMasterContentGetActiveGet } from '../fn/content/api-master-content-get-active-get';
import { ApiMasterContentGetActiveGet$Params } from '../fn/content/api-master-content-get-active-get';
import { apiMasterContentGetAllGet } from '../fn/content/api-master-content-get-all-get';
import { ApiMasterContentGetAllGet$Params } from '../fn/content/api-master-content-get-all-get';
import { apiMasterContentGetContentByMenuGet } from '../fn/content/api-master-content-get-content-by-menu-get';
import { ApiMasterContentGetContentByMenuGet$Params } from '../fn/content/api-master-content-get-content-by-menu-get';
import { apiMasterContentGetContentByMenuIdGet } from '../fn/content/api-master-content-get-content-by-menu-id-get';
import { ApiMasterContentGetContentByMenuIdGet$Params } from '../fn/content/api-master-content-get-content-by-menu-id-get';
import { apiMasterContentGetContentBySubMenuIdGet } from '../fn/content/api-master-content-get-content-by-sub-menu-id-get';
import { ApiMasterContentGetContentBySubMenuIdGet$Params } from '../fn/content/api-master-content-get-content-by-sub-menu-id-get';
import { Contents } from '../models/contents';
import { ContentsApiRespModel } from '../models/contents-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class ContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterContentAddPost()` */
  static readonly ApiMasterContentAddPostPath = '/api/Master/Content/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContentAddPost$Response(params?: ApiMasterContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsApiRespModel>> {
    return apiMasterContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContentAddPost(params?: ApiMasterContentAddPost$Params, context?: HttpContext): Observable<ContentsApiRespModel> {
    return this.apiMasterContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsApiRespModel>): ContentsApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterContentEditPost()` */
  static readonly ApiMasterContentEditPostPath = '/api/Master/Content/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContentEditPost$Response(params?: ApiMasterContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsApiRespModel>> {
    return apiMasterContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContentEditPost(params?: ApiMasterContentEditPost$Params, context?: HttpContext): Observable<ContentsApiRespModel> {
    return this.apiMasterContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsApiRespModel>): ContentsApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterContentApproveRejectPost()` */
  static readonly ApiMasterContentApproveRejectPostPath = '/api/Master/Content/ApproveReject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentApproveRejectPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContentApproveRejectPost$Response(params?: ApiMasterContentApproveRejectPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsApiRespModel>> {
    return apiMasterContentApproveRejectPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentApproveRejectPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterContentApproveRejectPost(params?: ApiMasterContentApproveRejectPost$Params, context?: HttpContext): Observable<ContentsApiRespModel> {
    return this.apiMasterContentApproveRejectPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsApiRespModel>): ContentsApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterContentDeleteGet()` */
  static readonly ApiMasterContentDeleteGetPath = '/api/Master/Content/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentDeleteGet$Response(params?: ApiMasterContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentDeleteGet(params?: ApiMasterContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterContentGetAllGet()` */
  static readonly ApiMasterContentGetAllGetPath = '/api/Master/Content/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetAllGet$Response(params?: ApiMasterContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Contents>>> {
    return apiMasterContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetAllGet(params?: ApiMasterContentGetAllGet$Params, context?: HttpContext): Observable<Array<Contents>> {
    return this.apiMasterContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Contents>>): Array<Contents> => r.body)
    );
  }

  /** Path part for operation `apiMasterContentGetContentByMenuIdGet()` */
  static readonly ApiMasterContentGetContentByMenuIdGetPath = '/api/Master/Content/GetContentByMenuId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentGetContentByMenuIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetContentByMenuIdGet$Response(params?: ApiMasterContentGetContentByMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Contents>> {
    return apiMasterContentGetContentByMenuIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentGetContentByMenuIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetContentByMenuIdGet(params?: ApiMasterContentGetContentByMenuIdGet$Params, context?: HttpContext): Observable<Contents> {
    return this.apiMasterContentGetContentByMenuIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Contents>): Contents => r.body)
    );
  }

  /** Path part for operation `apiMasterContentGetContentBySubMenuIdGet()` */
  static readonly ApiMasterContentGetContentBySubMenuIdGetPath = '/api/Master/Content/GetContentBySubMenuId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentGetContentBySubMenuIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetContentBySubMenuIdGet$Response(params?: ApiMasterContentGetContentBySubMenuIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Contents>> {
    return apiMasterContentGetContentBySubMenuIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentGetContentBySubMenuIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetContentBySubMenuIdGet(params?: ApiMasterContentGetContentBySubMenuIdGet$Params, context?: HttpContext): Observable<Contents> {
    return this.apiMasterContentGetContentBySubMenuIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Contents>): Contents => r.body)
    );
  }

  /** Path part for operation `apiMasterContentGetContentByMenuGet()` */
  static readonly ApiMasterContentGetContentByMenuGetPath = '/api/Master/Content/GetContentByMenu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentGetContentByMenuGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetContentByMenuGet$Response(params?: ApiMasterContentGetContentByMenuGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Contents>> {
    return apiMasterContentGetContentByMenuGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentGetContentByMenuGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetContentByMenuGet(params?: ApiMasterContentGetContentByMenuGet$Params, context?: HttpContext): Observable<Contents> {
    return this.apiMasterContentGetContentByMenuGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Contents>): Contents => r.body)
    );
  }

  /** Path part for operation `apiMasterContentGetActiveGet()` */
  static readonly ApiMasterContentGetActiveGetPath = '/api/Master/Content/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetActiveGet$Response(params?: ApiMasterContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Contents>>> {
    return apiMasterContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterContentGetActiveGet(params?: ApiMasterContentGetActiveGet$Params, context?: HttpContext): Observable<Array<Contents>> {
    return this.apiMasterContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Contents>>): Array<Contents> => r.body)
    );
  }

}
